var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"academy-synopsis"},[_c('AHeader',{attrs:{"currentIndex":1}}),_c('MeSwiper'),_c('div',{staticClass:"academy-synopsis-content"},[_c('div',[_vm._v("您当前的位置：首页>学院概况")]),_vm._m(0),_c('div',{domProps:{"innerHTML":_vm._s(_vm.schoolAboutDe.content)}})]),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v("学院")]),_c('span',[_vm._v("概况")])])
}]

export { render, staticRenderFns }